import { Controller } from "@hotwired/stimulus";
import { trackEvent } from "../helpers/event_tracker"

export default class extends Controller {
  static targets = [
    "passwordInput",
    "ssoActions",
    "emailActions",
    "agreeTermsCheckBox",
    "googleSignInButton",
    "azureSignInButton",
    "auth0SignInButton",
    "termsLabel",
    "signInWithMagicLink",
    "passwordField",
    "passwordToggleIcon", 
    "rememberEmail"  
  ];

  connect() {
    // Load remembered email if available
    const rememberedEmail = localStorage.getItem("rememberedEmail");
    const emailField = document.querySelector('input[type="email"]');
    const rememberCheckbox = document.getElementById('remember_email');
    
    if (rememberedEmail && emailField && rememberCheckbox) {
      emailField.value = rememberedEmail;
      rememberCheckbox.checked = true;
    }

  }

  agreeTermsCheckBoxTargetConnected() {
    this.agreeTermsCheckBoxTarget.addEventListener("change", () => {
      this.toggleSsoButtons();
    });
  }

  toggleSsoButtons() {
    const isAgreed = this.agreeTermsCheckBoxTarget.checked;
    const ssoButtons = document.querySelectorAll(".btn-auth");
    ssoButtons.forEach((button) => {
      button.classList.toggle("disabled", !isAgreed);
    });
  }

  ssoButtonClicked(event) {
    if (!this.agreeTermsCheckBoxTarget.checked) {
      event.preventDefault();
      const termsLabel = this.termsLabelTarget;
      termsLabel.classList.add("highlight");

      setTimeout(() => termsLabel.classList.remove("highlight"), 2000);
    }
  }

  toggleEmailAndPasswordContent() {
    $(this.emailActionsTarget).slideDown();
    $(this.ssoActionsTarget).slideUp();
    if(this.hasSignInWithMagicLinkTarget) $(this.signInWithMagicLinkTarget).slideUp();
  }

  toggleSsoContent() {
    $(this.ssoActionsTarget).slideDown();
    $(this.emailActionsTarget).slideUp();
    if(this.hasSignInWithMagicLinkTarget) $(this.signInWithMagicLinkTarget).slideUp();
  }

  toggleMagicLinkContent() {
    $(this.signInWithMagicLinkTarget).slideDown();
    $(this.emailActionsTarget).slideUp();
    $(this.ssoActionsTarget).slideUp();
  }

  async verify_registeration(e) {
    const hiddenInputCaptchaVersion = document.getElementById('captcha_version')
    
    if (hiddenInputCaptchaVersion && hiddenInputCaptchaVersion.value == 'v3') {
      e.preventDefault()
      
      const hiddenInput = document.getElementById('recaptcha_enterprise_token')
      
      if (window.grecaptcha && window.grecaptcha.enterprise) {
        try {
          const siteKey = document.querySelector('meta[name="recaptcha-site-key"]')?.content
          
          if (siteKey) {
            const token = await window.grecaptcha.enterprise.execute(siteKey, { action: 'signup' })
            if (hiddenInput) hiddenInput.value = token
            const form = e.target.closest('form')
            if (form) form.submit()
          } else {
            const form = e.target.closest('form')
            if (form) form.submit()
          }
          return
        } catch (err) {
          const form = e.target.closest('form')
          if (form) form.submit()
        }
      } else {
        const form = e.target.closest('form')
        if (form) form.submit()
      }
      return
    }
    const email = document.querySelector('[name="user[email]"]').value
    if (email) trackEvent('create_account', { email: email })
  }

  passwordInputTargetConnected() {
    this.setUpEventListeners();
    
    // Re-validate on Turbo updates (e.g., when v2 captcha loads)
    document.addEventListener('turbo:before-stream-render', () => {
      setTimeout(() => this.revalidatePassword(), 100)
    })
  }
  
  revalidatePassword() {
    if (!this.hasPasswordInputTarget) return
    
    const passwordInput = this.passwordInputTarget
    const form = passwordInput.closest("form")
    if (!form) return
    
    const validationElements = {
      uppercase: form.querySelector(".big-letter"),
      length: form.querySelector(".leng"),
      specialChar: form.querySelector(".special-character"),
      number: form.querySelector(".num"),
    }
    const signupButton = form.querySelector("#signup-button")
    
    if (passwordInput.value && signupButton) {
      this.validatePassword(passwordInput.value, validationElements, signupButton)
    }
  }

  setUpEventListeners() {
    const passwordInput = this.passwordInputTarget;
    const form = passwordInput.closest("form");
    const requirements = form.querySelectorAll(".validate-icon");
    const validationElements = {
      uppercase: form.querySelector(".big-letter"),
      length: form.querySelector(".leng"),
      specialChar: form.querySelector(".special-character"),
      number: form.querySelector(".num"),
    };
    const passwordValidateForm = form.querySelector("#password-validate");
    const signupButton = form.querySelector("#signup-button");

    requirements.forEach((requirement) => requirement.classList.add("wrong"));

    passwordInput.addEventListener("focus", () => {
      passwordValidateForm.classList.remove("d-none");
    });

    passwordInput.addEventListener("input", () => {
      const password = passwordInput.value;

      this.validatePassword(password, validationElements, signupButton);
    });
  }

  validatePassword(password, validationElements, signupButton) {
    const passwordValidateForm = document.querySelector("#password-validate");
    const validationRules = [
      { regex: /(?=.*[A-Z])/, element: validationElements.uppercase },
      { regex: /(?=.*\d)/, element: validationElements.number },
      {
        regex: /(?=.*[!@#$%^&*()\-=+\[\]{}\\|;:'",<.>\/?`~ ])/,
        element: validationElements.specialChar,
      },
      { regex: /.{8,}/, element: validationElements.length },
    ];

    validationRules.forEach(({ regex, element }) => {
      if (regex.test(password)) {
        element.classList.remove("wrong");
        element.classList.add("good");
      } else {
        element.classList.remove("good");
        element.classList.add("wrong");
      }
    });
    const allValid = validationRules.every(({ regex }) => regex.test(password));

    if (allValid) {
      passwordValidateForm.classList.add("d-none");
      signupButton.removeAttribute("disabled");
    } else {
      passwordValidateForm.classList.remove("d-none");
      signupButton.setAttribute("disabled", "disabled");
    }
  }
  togglePasswordVisibility(event) {
    event.preventDefault();
    // Support both passwordField and passwordInput targets
    const passwordField = this.hasPasswordFieldTarget ? this.passwordFieldTarget : this.passwordInputTarget;
    const icon = this.passwordToggleIconTarget;
    
    if (passwordField.type === "password") {
      passwordField.type = "text";
      icon.classList.replace("fa-eye", "fa-eye-slash");
    } else {
      passwordField.type = "password";
      icon.classList.replace("fa-eye-slash", "fa-eye");
    }
  }

  toggleRememberEmail() {
    const shouldRemember = this.rememberEmailTarget.checked;
    const emailField = document.querySelector('input[type="email"]');
    
    if (shouldRemember && emailField) {
      localStorage.setItem("rememberedEmail", emailField.value);
    } else {
      localStorage.removeItem("rememberedEmail");
    }
  }
}
